import Close from '@mui/icons-material/Close';
import { IconButton, Drawer, SxProps } from '@mui/material';
import { FC, ReactNode } from 'react';

const paperSx = (position: 'right' | 'left'): SxProps => ({
    backgroundColor: 'background.default',
    borderRadius: position === 'right' ? '8px 0 0 8px' : '0 8px 8px 0',
    p: 4,
    width: '60%',
});

interface SideModalProps {
    children: ReactNode;
    open: boolean;
    position?: 'right' | 'left';
    onClose?: () => void;
}

const SideModal: FC<SideModalProps> = ({ children, open, position = 'right', onClose }) => {
    return (
        <Drawer
            PaperProps={{ sx: paperSx(position) }}
            anchor={position}
            onClose={onClose}
            open={open}
        >
            <IconButton
                onClick={onClose}
                size="large"
                sx={{ position: 'absolute', right: 8, top: 8 }}
            >
                <Close />
            </IconButton>
            {children}
        </Drawer>
    );
};
export default SideModal;
